import { render, staticRenderFns } from "./Opp.vue?vue&type=template&id=664fcb61&"
import script from "./Opp.vue?vue&type=script&lang=js&"
export * from "./Opp.vue?vue&type=script&lang=js&"
import style0 from "./Opp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Opp.vue"
export default component.exports